export class Region {
  public id: string;
  public name: string;

  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }

  public static parse(data: RegionDto): Region {
    return new Region(data.id, data.name);
  }
}

export interface RegionDto {
  id: string;
  name: string;
}
